  import React, { useEffect, useState } from "react";
  import { FaSearch } from "react-icons/fa";

  const PickColumnsModal = ({ onSelectColumns, initialSelectedColumns = [ "Product Id","Status","Product Name", "Product HSN Code", "Product Category","Assigned To","Tags"], onClose }) => {
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const columns = {
      "General": ["Status", "Verified"],
      "Product Management": [
        "Product Added By", "Product Added Date", "Product Added Time",
        "Product Last Modified By", "Product Last Modified Date", "Product Last Modified Time",
        "Product Owner", "Product Recommended for", "Tags", "Next Step", "Assigned To"
      ],
      "Product Details": [
        "Product Id", "Product Name", "Product HSN Code", "Product Category",
        "Default Unit", "Indicative Min Price", "Indicative Max Price",
        "Product Price", "Product Old Price", "Product Discount",
        "Product Images", "Production Capacity", "Production Capacity Unit",
        "Present Stock Status", "Production Lead Time", "Minimum Order Quantity",
        "Minimum Order Quantity Unit", "Attached Product Certificates"
      ],
      "Product Life Span": ["Product Life", "Product LifeSpan"],
      "Description About Product": ["Product Certifications", "Product Description", "Product Varients"]
    };

    // ✅ Filter the categories and columns based on search term
    const filteredColumns = Object.keys(columns).reduce((acc, category) => {
      const filteredItems = columns[category].filter((column) =>
        column.toLowerCase().includes(searchTerm.toLowerCase())
      );
      if (filteredItems.length > 0) {
        acc[category] = filteredItems;
      }
      return acc;
    }, {});

    // ✅ Handle individual column select/deselect
    const handleCheckboxChange = (column) => {
      setSelectedColumns((prev) =>
        prev.includes(column)
          ? prev.filter((item) => item !== column)
          : [...prev, column]
      );
    };

    // ✅ Handle "Select All" for a category (only filtered columns)
    const handleSelectAll = (category) => {
      const allFilteredColumns = filteredColumns[category];
      const areAllSelected = allFilteredColumns.every((col) =>
        selectedColumns.includes(col)
      );

      if (areAllSelected) {
        setSelectedColumns((prev) =>
          prev.filter((col) => !allFilteredColumns.includes(col))
        );
      } else {
        setSelectedColumns((prev) => [
          ...prev,
          ...allFilteredColumns.filter((col) => !prev.includes(col))
        ]);
      }
    };

    // ✅ Handle Global "Select All" (only filtered columns)
    const handleGlobalSelectAll = () => {
      const allFilteredColumns = Object.values(filteredColumns).flat();
      const areAllSelected = allFilteredColumns.every((col) =>
        selectedColumns.includes(col)
      );

      if (areAllSelected) {
        setSelectedColumns((prev) =>
          prev.filter((col) => !allFilteredColumns.includes(col))
        );
      } else {
        setSelectedColumns((prev) => [
          ...prev,
          ...allFilteredColumns.filter((col) => !prev.includes(col))
        ]);
      }
    };

    // ✅ Check if all filtered columns are selected globally
    const isGlobalSelectAll = Object.values(filteredColumns)
      .flat()
      .every((col) => selectedColumns.includes(col));

    // ✅ Pass selected columns to parent and close modal
    const handleSubmit = () => {
      if (typeof onSelectColumns === "function") {
        onSelectColumns(selectedColumns); // Pass data up
        onClose()
      }
    };

    useEffect(() => {
      setSelectedColumns(initialSelectedColumns);
    }, []);

    

    return (
      <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white rounded-lg w-4/5 md:w-1/3 p-6 shadow-lg">
          {/* Modal Title */}
          <div className="flex justify-between items-center border-b border-gray-300 pb-3">
            <h2 className="text-lg font-semibold">Pick Columns</h2>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
              ✕
            </button>
          </div>

          {/* Search Bar */}
          <div className="flex justify-between items-center p-4">
            <div className="relative w-2/3">
              <input
                type="text"
                placeholder="Search columns..."
                className="rounded-md px-4 py-2 w-full bg-blue-100 outline-blue-100"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <FaSearch className="absolute right-3 top-3 text-gray-500" />
            </div>
            {/* Global Select All */}
            <input
              type="checkbox"
              className="form-checkbox h-4 w-4 text-blue-500 scale-125 cursor-pointer"
              checked={isGlobalSelectAll}
              onChange={handleGlobalSelectAll}
            />
          </div>

          {/* Column List */}
          <div className="max-h-80 overflow-y-auto py-2">
            {Object.keys(filteredColumns).length > 0 ? (
              Object.keys(filteredColumns).map((category) => {
                const areAllSelected = filteredColumns[category].every((col) =>
                  selectedColumns.includes(col)
                );

                return (
                  <div key={category}>
                    {/* Category Title with Select All */}
                    <div className="flex items-center justify-between gap-3 p-3">
                      <h1 className="text-gray-600 font-bold">{category}</h1>
                      <input
                        type="checkbox"
                        className="form-checkbox h-4 w-4 text-blue-500 scale-125 cursor-pointer"
                        checked={areAllSelected}
                        onChange={() => handleSelectAll(category)}
                      />
                    </div>

                    {/* Columns under each category */}
                    <div className="grid grid-cols-2 gap-4 p-3">
                      {filteredColumns[category].map((column) => (
                        <div key={column} className="flex items-center gap-3 cursor-pointer">
                          <input
                            type="checkbox"
                            className="form-checkbox h-4 w-4 text-blue-500 scale-125"
                            checked={selectedColumns.includes(column)}
                            onChange={() => handleCheckboxChange(column)}
                          />
                          <span>{column}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })
            ) : (
              <p className="text-gray-500 text-sm text-center py-2">
                No matching columns found.
              </p>
            )}
          </div>

          {/* Submit Button */}
          <div className="flex items-center justify-end p-2">
            <button
              onClick={handleSubmit}
              className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    );
  };

  export default PickColumnsModal;
